import { RouteConfig } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const procedureDocumentationRoute: RouteConfig = {
  path: 'documentation',
  name: 'procedureDocumentation',
  component: () =>
    import(/* webpackChunkName: "ProcedureDocumentation" */ '@/views/mainRoute/procedure/details/Documentation.vue'),
  beforeEnter: (to, from, next) => {
    const structureNodeIds = store.state.auth.nodes?.map((node: any) => node.id);
    const procedureId = to.params.procedureId;
    const filters: any = { order: 'order', desc: false, count: -1, type: AttachmentType.GENERATED };

    if (structureNodeIds?.length) {
      filters.structureNodeIds = structureNodeIds;
      filters.procedureId = tryParseInt(procedureId);
    } else {
      filters.entityType = EntityType.PROCEDURE;
      filters.entityId = procedureId.toString();
    }

    Promise.all([
      store.dispatch('procedure/attachment/list', filters),
      store.dispatch('auth/checkPermissions', 'ATTACHMENT.ADD'),
      store.dispatch('setting/findPublic', {
        code: PublicSettings.PROCEDURE_ATTACHMENT_COLUMN_NAME,
        entityType: EntityType.PROCEDURE,
        entityId: to.params.procedureId.toString()
      })
    ])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.ATTACHMENT_CANNOT_LIST }));
  }
};
